<template>
    <div class="container">
        <p class="display-6"><br>Page not Found</p>
    </div>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>